@if (clearButton()) {
  <button mat-icon-button (click)="onClick(0)">
    <fa-icon [icon]="['far', 'times']" transform="left-2 up-2"></fa-icon>
  </button>
}
@for (ratingId of ratingArr(); track $index; let i = $index) {
  <button
    mat-icon-button
    [ngStyle]="{ color: color() }"
    [id]="'star_' + i"
    (click)="onClick(i + 1)"
    [matTooltip]="ratingId + 1 + ''"
    matTooltipPosition="above">
    <fa-icon
      [icon]="[i | showIcon: rating(), 'circle']"
      size="2xs"
      transform="left-2 up-2"></fa-icon>
  </button>
}
@let starCountValue = starCount();
@if ((starCountValue | isNil) || starCountValue === 0) {
  <mat-error>
    Star count is <strong>required</strong> and cannot be zero
  </mat-error>
}
